module.exports = __webpack_public_path__ + "img/1.4f989864.png";